import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import { styled } from "@mui/material/styles";
import Typography from "@mui/material/Typography";
import TextField from "@mui/material/TextField";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useState } from "react";
import createInstance from "../../../api/axiosinstance";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import "./index.css";
import { Button } from "@mui/material";
import Toast from "../../../utils/toast";
import Autocomplete from "@mui/material/Autocomplete";
import Loader from "../../Loader";

const CssFormControl = styled(FormControl)({
  "& label": {
    color: "#033538",
    "&.Mui-focused": {
      color: "#B9B9B9",
    },
  },
  "& .MuiInputBase-root": {
    color: "#FF0000",
    "& .MuiOutlinedInput-notchedOutline": {
      borderColor: "#033538",
      borderRadius: 10,
    },
    "&:hover .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B9B9B9",
    },
    "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
      borderColor: "#B9B9B9",
    },
  },
});

const CssSelect = styled(Select)({
  "& .MuiSvgIcon-root": {
    color: "#033538",
    textAlign: "center",
  },
});

const CssTextField = styled(TextField)({
  "& label.Mui-focused": {
    color: "#033538",
  },
  "& label": {
    color: "#033538",
  },
  "& .MuiInput-underline:after": {
    borderBottomColor: "#B9B9B9",
  },
  "& .MuiOutlinedInput-root": {
    "& fieldset": {
      borderColor: "#033538",
      borderRadius: 10,
    },
    "&:hover fieldset": {
      borderColor: "#B9B9B9",
    },
    "&.Mui-focused fieldset": {
      borderColor: "#B9B9B9",
    },
    "& .MuiInputBase-input": {
      color: "#033538",
    },
  },
});

const ScheduleInterview = ({ onOpenAddOrganization }) => {
  const aiDishaApi = createInstance("DISHA");
  const [candidateId, setCandidateId] = useState("");
  const [candidates, setCandidates] = useState([]);
  const [candidateName, setCandidateName] = useState("");
  const [jobs, setJobs] = useState([]);
  const [jobTitle, setJobTitle] = useState("");
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [jobId, setJobId] = useState();
  // const [meetingPlatform, setMeetingPlatform] = useState("");
  const [meetingLink, setMeetingLink] = useState("");
  const [round, setRound] = useState("");
  const [keyNotes, setKeyNotes] = useState("");
  const [interviewer, setInterviewer] = useState("");
  const [interviewerList, setInterviewerList] = useState([]);
  const [technologists, setTechnologists] = useState([]);
  const [managers, setManagers] = useState([]);
  const [hrs, setHrs] = useState([]);
  const [isLoading, setIsLoading] = useState(false); // Added loading state
  const [initialLoading, setInitialLoading] = useState(true); // For initial data loading
  const organizationId = window.sessionStorage.getItem("organizationId");

  useEffect(() => {
    if (candidateId) {
      var candName = "";
      const candidate = candidates.find(
        (candidate) => candidate.candidate_id === candidateId
      );
      if (candidate) {
        candName = candidate.candidate_full_name;
        setJobTitle(candidate.job_title);
        setJobId(candidate.job_id);
      }
      setCandidateName(candName);
    } else {
      setCandidateName("");
    }
  }, [candidateId]);

  useEffect(() => {
    if (round) {
      if (round === "Technical Round 1" || round === "Technical Round 2") {
        setInterviewerList(technologists);
      } else if (round === "Managerial") {
        setInterviewerList(managers);
      } else if (round === "HR") {
        setInterviewerList(hrs);
      }
    }
  }, [round]);

  useEffect(() => {
    const loadInitialData = async () => {
      setInitialLoading(true);
      try {
        await Promise.all([
          getAllCandidates(),
          getAllJobs(),
          getInterviewers(),
        ]);
      } catch (error) {
        console.error("Error loading initial data:", error);
        Toast.error("Failed to load initial data. Please refresh the page.");
      } finally {
        setInitialLoading(false);
      }
    };

    loadInitialData();
  }, []);

  const getAllCandidates = async () => {
    try {
      const response = await aiDishaApi.get(
        `/get-candidates-by-org-id/?org_id=${organizationId}`
      );
      setCandidates(response.data["candidates"]);
      console.log("candidates",response.data)
      return response;
    } catch (error) {
      console.error("Error fetching list of candidates", error);
      throw error;
    }
  };

  const getAllJobs = async () => {
    try {
      const response = await aiDishaApi.get(
        `/all_active_jobs?org_id=${organizationId}`
      );
      setJobs(response.data);
      return response;
    } catch (error) {
      console.error("Error fetching list of jobs", error);
      throw error;
    }
  };

  const getInterviewers = async () => {
    try {
      const response = await aiDishaApi.get(
        `/get_interviewers?org_id=${organizationId}`
      );
      const interviewers = response.data;
      console.log("interviewrs", interviewers);
      setTechnologists(interviewers["Technical"]);
      setHrs(interviewers["HR"]);
      setManagers(interviewers["Managerial"]);
      return response;
    } catch (error) {
      console.log("Error fetching interviewers", error);
      throw error;
    }
  };

  // const handlePlatform = async (platform) => {
  //   setMeetingPlatform(platform);

  //   if (platform === "Zoom") {
  //     setIsLoading(true);
  //     try {
  //       await getMeetingLink();
  //     } finally {
  //       setIsLoading(false);
  //     }
  //   } else {
  //     setMeetingLink("");
  //   }
  // };

  // const getMeetingLink = async () => {
  //   try {
  //     const response = await aiDishaApi.post("/zoom-meeting-creator/");
  //     setMeetingLink(response.data["Join URL"]);
  //     return response;
  //   } catch (error) {
  //     console.error("Error fetching meeting link", error);
  //     Toast.error("Failed to generate Zoom meeting link");
  //     throw error;
  //   }
  // };

  const fetchCandidateName = (candidateId) => {
    setCandidateId(candidateId);
  };

  const handleInterviewer = (interviewer) => {
    setInterviewer(interviewer);
  };

  const validateForm = () => {
    if (!candidateId.trim()) {
      Toast.error("Candidate ID cannot be empty");
      return false;
    }
    if (!jobTitle.trim()) {
      Toast.error("Job Title cannot be empty");
      return false;
    }
    // if (!meetingPlatform.trim()) {
    //   Toast.error("Meeting Platform cannot be empty");
    //   return false;
    // }
    if (!meetingLink.trim()) {
      Toast.error("Meeting Link cannot be empty");
      return false;
    }
    if (!round.trim()) {
      Toast.error("Round cannot be empty");
      return false;
    }
    if (!keyNotes.trim()) {
      Toast.error("Key notes cannot be empty");
      return false;
    }
    if (!interviewer.trim()) {
      Toast.error("Interviewer cannot be empty");
      return false;
    }
    if (!selectedDate) {
      Toast.error("Interview Date cannot be empty");
      return false;
    }
    if (!selectedTime) {
      Toast.error("Interview Time cannot be empty");
      return false;
    }
    return true;
  };

  const saveInterviewDetails = async (event) => {
    event.preventDefault();
  
    if (!validateForm()) {
      return;
    }
  
    setIsLoading(true);
  
    let formattedDateTime = "";
    if (selectedDate && selectedTime) {
      // Combine date and time
      const combinedDateTime = new Date(
        selectedDate.getFullYear(),
        selectedDate.getMonth(),
        selectedDate.getDate(),
        selectedTime.getHours(),
        selectedTime.getMinutes(),
        selectedTime.getSeconds()
      );
  
      // Validate that the selected date and time are in the future
      const now = new Date();
      if (combinedDateTime <= now) {
        Toast.error("Please select a future date and time");
        setIsLoading(false);
        return;
      }
  
      // Format to local date-time with timezone offset
      const pad = (num) => String(num).padStart(2, "0");
      const timezoneOffset = -combinedDateTime.getTimezoneOffset(); // Offset in minutes
      const offsetHours = Math.floor(timezoneOffset / 60);
      const offsetMinutes = Math.abs(timezoneOffset % 60);
      const offsetSign = timezoneOffset >= 0 ? "+" : "-";
      formattedDateTime = `${combinedDateTime.getFullYear()}-${pad(
        combinedDateTime.getMonth() + 1
      )}-${pad(combinedDateTime.getDate())}T${pad(
        combinedDateTime.getHours()
      )}:${pad(combinedDateTime.getMinutes())}:${pad(
        combinedDateTime.getSeconds()
      )}${offsetSign}${pad(offsetHours)}:${pad(offsetMinutes)}`;
  
      console.log("Formatted DateTime (Local with Offset):", formattedDateTime);
    } else {
      Toast.error("Date or time not selected");
      setIsLoading(false);
      return;
    }
  
    try {
      const response = await aiDishaApi.post(
        "/schedule_interview",
        {},
        {
          params: {
            organization_id: organizationId,
            candidate_id: candidateId,
            candidate_name: candidateName,
            job_title: jobTitle,
            Interview_panel: interviewer,
            link: meetingLink,
            round: round,
            Key_notes: keyNotes,
            interview_date_and_time: formattedDateTime,
          },
          paramsSerializer: {
            indexes: null,
          },
        }
      );
  
      console.log("Interview details:", response.data);
      clearForm();
      Toast.success("Interview scheduled successfully");
    } catch (error) {
      console.log("Error scheduling interview:", error);
      Toast.error("Failed to schedule interview. Please try again.");
    } finally {
      setIsLoading(false);
    }
  };

  const clearForm = () => {
    setCandidateId("");
    setCandidateName("");
    setJobTitle("");
    // setMeetingPlatform("");
    setMeetingLink("");
    setRound("");
    setKeyNotes("");
    setInterviewer("");
    setSelectedDate(null);
    setSelectedTime(null);
  };

  if (initialLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
        }}
      >
        <Loader />
      </div>
    );
  }

  return (
    <div
      style={{
        height: "calc(100% - 6%)",
        overflow: "scroll",
        overflowX: "hidden",
        scrollbarWidth: "thin",
        msOverflowStyle: "none",
        scrollbarColor: "transparent transparent",
        "&::-webkit-scrollbar": {
          width: "5px",
          height: "5px",
        },
        position: "relative", // Added for loader positioning
      }}
    >
      {isLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            backgroundColor: "rgba(255, 255, 255, 0.7)",
            zIndex: 1000,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Loader />
        </div>
      )}

      <Box
        display="grid"
        gridTemplateColumns="repeat(12, 1fr)"
        sx={{
          marginTop: "auto",
          alignItems: "center",
          borderRadius: "10px",
          padding: "1% 1%",
        }}
      >
        <Box
          gridColumn="span 12"
          sx={{ marginTop: "auto", textAlign: "left", marginBottom: "0%" }}
        >
          <Typography
            sx={{ fontFamily: "poppins", fontSize: "28px", color: "#006A71" }}
          >
            Scheduled Online Interview
          </Typography>
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Candidate ID
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#033538" }}>
            <Autocomplete
              options={candidates}
              getOptionLabel={(option) =>
                `${option.candidate_id} - ${option.candidate_full_name}`
              }
              onChange={(e, value) =>
                fetchCandidateName(value ? value.candidate_id : "")
              }
              renderInput={(params) => (
                <CssTextField
                  {...params}
                  label="Search by ID or Name"
                  size="small"
                  sx={{ width: "95%" }}
                />
              )}
              value={
                candidates.find((c) => c.candidate_id === candidateId) || null
              }
              sx={{ width: "90%" }}
            />
          </CssFormControl>
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Candidate Name
          </Typography>
          <CssTextField
            value={candidateName}
            size="small"
            sx={{ width: "95%" }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Job Title
          </Typography>
          <CssTextField
            value={jobTitle + (jobId ? " (" + jobId + ")" : "")}
            size="small"
            sx={{ width: "95%" }}
            InputProps={{ readOnly: true }}
          />
        </Box>

        {/* <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Meeting Platform
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#033538" }}>
            <InputLabel>Select Meeting Platform</InputLabel>
            <CssSelect
              label="Select Meeting Platform"
              value={meetingPlatform}
              onChange={(e) => handlePlatform(e.target.value)}
              size="small"
              sx={{
                width: "105%",
                textAlign: "center",
                color: "#033538",
                "& .MuiSelect-select": {
                  color: "#033538",
                },
              }}
              required={true}
            >
              <MenuItem value="" disabled sx={{ color: "#273746" }}>
                Select Platform
              </MenuItem>
              <MenuItem key="Zoom" value="Zoom" sx={{ color: "black" }}>
                Zoom
              </MenuItem>
            </CssSelect>
          </CssFormControl>
        </Box> */}

        <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Meeting Link
          </Typography>
          <CssTextField
            label="Enter Meeting Link"
            value={meetingLink}
            size="small"
            sx={{ width: "95%" }}
            onChange={(e) => setMeetingLink(e.target.value)} // Add this to make it editable
          />
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Round
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#FFFFFF" }}>
            <InputLabel>Select Round</InputLabel>
            <CssSelect
              label="Select Round"
              value={round}
              onChange={(e) => setRound(e.target.value)}
              size="small"
              sx={{
                width: "105%",
                textAlign: "center",
                color: "#033538",
                "& .MuiSelect-select": {
                  color: "#033538",
                },
              }}
              required={true}
            >
              <MenuItem value="" disabled sx={{ color: "black" }}>
                Select Interviewer
              </MenuItem>
              <MenuItem
                key="Technical Round 1"
                value="Technical Round 1"
                sx={{ color: "black" }}
              >
                Technical Round 1
              </MenuItem>
              <MenuItem
                key="Technical Round 2"
                value="Technical Round 2"
                sx={{ color: "black" }}
              >
                Technical Round 2
              </MenuItem>
              <MenuItem
                key="Managerial"
                value="Managerial"
                sx={{ color: "black" }}
              >
                Managerial
              </MenuItem>
              <MenuItem key="HR" value="HR" sx={{ color: "black" }}>
                HR
              </MenuItem>
            </CssSelect>
          </CssFormControl>
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "15px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Key Notes
          </Typography>
          <CssTextField
            label="Key Notes"
            required
            value={keyNotes}
            size="small"
            sx={{ width: "95%", color: "#033538" }}
            onChange={(e) => setKeyNotes(e.target.value)}
          />
        </Box>

        <Box gridColumn="span 6" sx={{ marginTop: "12px", textAlign: "left" }}>
          <Typography sx={{ fontFamily: "poppins", color: "#033538" }}>
            Interviewer
          </Typography>
          <CssFormControl sx={{ width: "90%", color: "#033538" }}>
            <InputLabel>Select Interviewer</InputLabel>
            <CssSelect
              label="Select Interviewer"
              value={interviewer}
              onChange={(e) => handleInterviewer(e.target.value)}
              size="small"
              sx={{
                width: "105%",
                textAlign: "center",
                color: "#033538",
                "& .MuiSelect-select": {
                  color: "#033538",
                },
              }}
              required={true}
            >
              <MenuItem value="" sx={{ color: "black" }}>
                Select Interviewer
              </MenuItem>
              {interviewerList.map((techi) => (
                <MenuItem
                  key={techi.panelist_id}
                  value={techi.panelist_id}
                  sx={{ color: "black" }}
                >
                  {techi.full_name} - {techi.panelist_id}
                </MenuItem>
              ))}
            </CssSelect>
          </CssFormControl>
        </Box>
      </Box>

      <Box
        gridColumn="span 12"
        sx={{
          marginTop: "15px",
          marginBottom: "15px",
          textAlign: "left",
          borderColor: "#033538",
          borderWidth: "20px",
          marginLeft: "15px",
        }}
      >
        <Typography
          sx={{ fontFamily: "poppins", fontSize: "20px", color: "#033538" }}
        >
          Interview Date and Time
        </Typography>
      </Box>

      <div
  style={{
    padding: "20px",
    maxWidth: "400px",
    margin: "0",
    border: "1px solid #033538",
    borderRadius: "10px",
    position: "relative",
    left: "1%",
    marginTop: "5px",
  }}
>
  <div style={{ marginBottom: "20px", color: "#033538" }}>
    <label style={{ color: "#033538" }}>Date : </label>
    <DatePicker
      className="custom-datepicker"
      selected={selectedDate}
      onChange={(date) => setSelectedDate(date)}
      dateFormat="yyyy/MM/dd"
      placeholderText="Select a date"
      minDate={new Date()} // Disable past dates
    />
  </div>
  <div style={{ marginBottom: "20px" }}>
    <label style={{ color: "#033538" }}>Time : </label>
    <DatePicker
      className="custom-datepicker"
      selected={selectedTime}
      onChange={(time) => setSelectedTime(time)}
      showTimeSelect
      showTimeSelectOnly
      timeIntervals={15}
      timeCaption="Time"
      timeFormat="HH:mm"
      dateFormat="HH:mm"
      placeholderText="Select a time"
    />
  </div>
  {selectedDate && selectedTime && (
    <div style={{ color: "#033538", fontSize: "14px" }}>
      <p>
        Selected Interview Time (IST):{" "}
        {new Date(
          selectedDate.getFullYear(),
          selectedDate.getMonth(),
          selectedDate.getDate(),
          selectedTime.getHours(),
          selectedTime.getMinutes(),
          selectedTime.getSeconds()
        ).toLocaleString("en-US", {
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
          hour12: false,
        })}
      </p>
    </div>
  )}
</div>

      <Box
        gridColumn="span 12"
        sx={{ marginTop: "auto", textAlign: "right", width: "90%" }}
      >
        <Button
          type="button"
          className="btn btn-sm rounded-2 fw-medium"
          onClick={clearForm}
          disabled={isLoading}
          sx={{
            border: "1px solid",
            color: "#033538",
            width: "120px",
            height: "35px",
            borderRadius: "10px",
            marginRight: "4%",
          }}
        >
          Clear
        </Button>

        <Button
          type="submit"
          className="btn btn-sm rounded-2 fw-medium"
          disabled={isLoading}
          sx={{
            border: "1px solid",
            color: "white",
            width: "120px",
            height: "35px",
            borderRadius: "10px",
            backgroundColor: "#006A71",
            "&:hover": {
              backgroundColor: "033538",
            },
          }}
          onClick={(e) => saveInterviewDetails(e)}
        >
          Submit
        </Button>
      </Box>

      <br />
      <br />
      <br />
    </div>
  );
};

export default ScheduleInterview;
